export const SousDispositif = ['CarteChrono', 'CarteBtp', 'BadgeAero'] as const

export type SousDispositif = (typeof SousDispositif)[number]

export const SousDispositifLibelle: Record<SousDispositif, string> = {
  CarteChrono: 'Carte chronotachygraphe (chrono)',
  CarteBtp: 'Carte BTP',
  BadgeAero: 'Badge Aéroportuaire (Aéro)',
} as const
